import React from "react";
import CalendarDatePicker from "ui/components/comp-507";
import TagsCombobox from "components/directus/combobox/tags";
import { formatDateForAPI } from "utils/utils";

const JobTimesheetLogsFilters = ({ filters, setFilters }) => {
  return (
    <div className="flex gap-2">
      <TagsCombobox
        value={filters?.tag?.id}
        onChange={(value) => setFilters({ ...filters, tag: { _eq: value } })}
        for="timesheet"
        hideLabel
        className="w-40"
      />
      <CalendarDatePicker
        hideLabel={true}
        date={{
            from: filters?.date?._gte,
            to: filters?.date?._lte,
        }}
        setDate={(range) =>
            setFilters({
                ...filters,
                date: {
                    _gte: range?.from ? formatDateForAPI(range.from) : undefined,
                    _lte: range?.to ? formatDateForAPI(range.to) : undefined,
                },
            })
        }
      />
    </div>
  );
};

export default JobTimesheetLogsFilters;
